import { Dispatch, useReducer } from "react";
import { EditorState } from "../types/editor-state.types";
import { editorStateReducer } from "../helpers/editor.reducer";
import { EditorAction } from "../types/editor-action.types";

const createEmptyState = (): EditorState => ({
  canvasView: { x: -50, y: -100 },
  nodes: {},
  positions: {},
});

export function useEditorState(initialState = createEmptyState) {
  const [state, dispatch] = useReducer(
    editorStateReducer,
    undefined,
    initialState
  );

  return [state, dispatch] as [EditorState, Dispatch<EditorAction>];
}
